import React, { Fragment } from 'react';
import DraftSharingPermissions from './DraftSharingPermissions';

const DraftPeople = (props) => (
    <Fragment>
        <div id="draft-permissions-container" className="draft-viewers">
            <DraftSharingPermissions />
        </div>
    </Fragment>
);

export default DraftPeople;
